import React from 'react';
import { Paragraph as RNParagraph } from 'react-native-paper';
import styled from 'styled-components/native';

import Avatar from '@src/components/Avatar';
import { Comment } from '@src/types';

type Props = {
  data?: Comment;
};

const Container = styled.View`
  padding-start: 10px;
  flex-direction: row;
  align-items: center;
`;

const Paragraph = styled(RNParagraph)`
  margin-start: 5px;
`;

const User = styled(Avatar)`
  align-self: flex-start;
`;

const Component: React.FC<Props> = ({ data }) => {
  return (
    <Container>
      <User source={data?.user?.avatar} />
      <Paragraph>{data?.content}</Paragraph>
    </Container>
  );
};

Component.displayName = 'CommentCard';

export default React.memo(Component);
